'use client'
import Head from 'next/head'
import { useState } from 'react'

import { Alert, Divider, Link } from '@/components'
import { pages } from '@/settings'
import ConfirmPassword from './_confirmPassword'
import ForgotPassword from './_forgotPassword'

export default function ClientPage() {
  const [email, setEmail] = useState('')
  const emailChanged = (email: string) => {
    setEmail(email)
  }

  const [isConfirmed, setIsConfirmed] = useState(false)
  const confirmed = (confirmed: boolean) => {
    setIsConfirmed(confirmed)
  }

  return (
    <>
      <Head>
        <title>Forgot Password</title>
      </Head>
      <h2 className='mt-10 text-center text-3xl/9 font-bold tracking-tight'>Forgot Password</h2>
      {isConfirmed && <Alert variant='success' message='Password reset successfully' className='text-center mt-4' />}
      <div className='pt-4 pb-6 text-center'>
        [ <Link href={pages.signIn.href}>Go Back to Sign In</Link> ]
      </div>
      {!isConfirmed && (
        <>
          <ForgotPassword sendEmailBack={emailChanged} />
          <Divider className='my-8' />
          <ConfirmPassword email={email || ''} sendConfirmBack={confirmed} />
        </>
      )}
    </>
  )
}
